import naviSearchModel from './naviSearchModel';

const transitSetting = ({
  naviSearch,
  setNaviSearch
}) => {
  const togglePreferences = (type) => {
    const display = type === naviSearch.type ? 'block' : 'none';
    return {display};
  };

  // 設定クリア（初期値に戻す）
  const setDefaultSettings = () => {
    // 時刻は現在時刻をセットする
    let now = new Date();
    naviSearchModel.transit.date = `${now.getFullYear()}${('0' + (now.getMonth() + 1)).slice(-2)}${('0' + now.getDate()).slice(-2)}`; // 今日の日付
    naviSearchModel.transit.time = `${('0' + now.getHours()).slice(-2)}${('0' + now.getMinutes()).slice(-2)}`; // 今の時刻
    setNaviSearch({...naviSearch, transit: {...naviSearchModel.transit}});
  };      


  /*
   * 日付関連の処理 start
   * 1年前から1年後までの年月を選択肢として表示する
   * 例：2023年10月 ～ 2025年10月
   * ただし、日付は選択した年月に応じて変化させる
   * 例：2024年02月 → 1-29日、2024年04月 → 1-30日、2024年05月 → 1-31日
   */
  const RANGE_OF_YEARS_PAST = 1; // 過去1年分
  const RANGE_OF_YEARS_FUTURE = 1; // 未来1年分
  let today = new Date();
  let oneMonthAgo = new Date();
  oneMonthAgo.setMonth(oneMonthAgo.getMonth() - RANGE_OF_YEARS_PAST);
  let oneYearLater = new Date();
  oneYearLater.setFullYear(oneYearLater.getFullYear() + RANGE_OF_YEARS_FUTURE);

  // 年月のオプション用の配列を作成
  let yearMonth = [];
  for (let y = oneMonthAgo.getFullYear(); y <= oneYearLater.getFullYear(); y++) {
    let startMonth = (y === oneMonthAgo.getFullYear()) ? oneMonthAgo.getMonth() + 1 : 1;
    let endMonth = (y === oneYearLater.getFullYear()) ? oneYearLater.getMonth() + 1 : 12;
    for (let m = startMonth; m <= endMonth; m++) {
      yearMonth.push({year: y, month: ('0' + m).slice(-2)});
    }
  }
  naviSearch.transit.date = naviSearch.transit.date 
    || `${today.getFullYear()}${('0' + (today.getMonth() + 1)).slice(-2)}${('0' + today.getDate()).slice(-2)}`; // 初期値設定
  
  // 選択した年月から日付のオプションを生成
  let selectedYear = parseInt(naviSearch.transit.date.substr(0, 4));
  let selectedMonth = parseInt(naviSearch.transit.date.substr(4, 2));
  let daysInMonth = new Date(selectedYear, selectedMonth, 0).getDate(); // 月の日数を取得
  let dayOptions = [];
  for (let d = 1; d <= daysInMonth; d++) {
    dayOptions.push(('0' + d).slice(-2));
  }

  // 日付をセットする関数
  const setDate = (year, month, day) => {
    const newDate = `${year}${month}${day}`;
    setNaviSearch({...naviSearch, transit: {...naviSearch.transit, date: newDate}});
  }

  // 時刻のオプション用の配列を作成
  naviSearch.transit.time = naviSearch.transit.time
    || `${('0' + today.getHours()).slice(-2)}${('0' + today.getMinutes()).slice(-2)}`; // 初期値設定
  const hourOptions = [];
  for (let h = 0; h < 24; h++) {
    hourOptions.push(('0' + h).slice(-2));
  }
  const minuteOptions = [];
  for (let m = 0; m < 60; m++) {
    minuteOptions.push(('0' + m).slice(-2));
  }

  // 時刻をセットする関数
  const setTime = (hour, minute) => {
    const newTime = `${hour}${minute}`;
    setNaviSearch({...naviSearch, transit: {...naviSearch.transit, time: newTime}});
  } 

  // 現在の年月日時刻をセットする関数
  const setCurrentDateTime = () => {
    let now = new Date();
    const currentDate = `${now.getFullYear()}${('0' + (now.getMonth() + 1)).slice(-2)}${('0' + now.getDate()).slice(-2)}`;
    const currentTime = `${('0' + now.getHours()).slice(-2)}${('0' + now.getMinutes()).slice(-2)}`;
    console.log("Current date and time:", currentDate, currentTime);
    setNaviSearch({...naviSearch,
      transit: {...naviSearch.transit, 
        date: currentDate,
        time: currentTime,
        transitMode: 0 // transitModeを0:出発に変更 ※現在時刻に合わせたら必然的に出発になるはず
      }
    });
    
  }

  /*
   * 交通機関選択のチェックボックスの状態を管理する
   * ※かなり複雑で、8桁の文字型の数値でフラグが立つ構造になっている
   */
  let useAir = naviSearch.transit.transportation.charAt(2) === '0'; // 2:飛行機
  let useShinkansen = naviSearch.transit.transportation.charAt(3) === '0'; // 3:新幹線
  let useLimitedExpress = naviSearch.transit.transportation.charAt(4) === '0'; // 4:有料特急
  const setTransportation = () =>{
    let transportation = [
      0,
      0,
      useAir? 0 : 2,  // 飛行機を使う 0: 利用する 2: 利用しない
      useShinkansen? 0 : 2,  // 新幹線を使う 0: 利用する 2: 利用しない
      useLimitedExpress? 0 : 2,  // 有料特急を使う 0: 利用する 2: 利用しない
      useLimitedExpress? 0 : 2,  // 有料特急を使う 0: 利用する 2: 利用しない
      useLimitedExpress? 0 : 2,  // 有料特急を使う 0: 利用する 2: 利用しない
      0 
    ].join('');
    setNaviSearch({...naviSearch, transit: {...naviSearch.transit, transportation}});
  };

  const setSort = (sortIndex) => {
    let sort = [
      'time,fare,transfer', //  時間順
      'fare,time,transfer', //  料金順
      'transfer,fare,time'  //  乗り換え順
    ];
    setNaviSearch({...naviSearch, transit: {...naviSearch.transit, sort: sort[sortIndex]}});
  };

  return (
          <div className="transit-options route-option-group" style={togglePreferences('transit')}>

              {/* 条件変更・設定クリア */}
              <div className="transit-controls">
                  <button type="button" className="transit-control-btn" id="change-conditions" onClick={() => setNaviSearch({...naviSearch, reSearchFlag: true})}>
                      <i className="svg-icon-blue" style={{ backgroundImage: `url('assets/icons/settings_24.svg')` }}></i> 条件を変更
                  </button>
                  <button type="button" className="transit-control-btn" id="clear-settings" onClick={setDefaultSettings}>
                      <i className="svg-icon-blue" style={{ backgroundImage: `url('assets/icons/close_24.svg')` }}></i> 設定をクリア
                  </button>
              </div>

              {/* 日時設定 */}
              <div className="datetime-settings">
                  <div className="datetime-selects">
                      <select id="transit-year" className="datetime-select"
                        value={naviSearch.transit.date.substr(0,6)}
                        onChange={(e) => setDate(e.target.value.substr(0,4), e.target.value.substr(4,2), naviSearch.transit.date.substr(6,2)) }
                      >
                        {/* 2025年10月 のようにオプションが1年分動的に生成される */}
                        {yearMonth.map((ym, index) => (
                            <option key={index} value={`${ym.year}${ym.month}`}>
                              {`${ym.year}年${ym.month}月`}
                            </option>
                        ))}
                      </select>
                      <select id="transit-day" className="datetime-select"
                        value={naviSearch.transit.date.substr(6,2)}
                        onChange={(e) => setDate(naviSearch.transit.date.substr(0,4), naviSearch.transit.date.substr(4,2), e.target.value) }
                      >
                          {/* 日のオプションが動的に生成される */}
                          {dayOptions.map((day, index) => (
                            <option key={index} value={day}>
                              {`${day}日`}
                            </option>
                          ))}
                      </select>
                      <select id="transit-hour" className="datetime-select"
                        value={naviSearch.transit.time.substr(0,2)}
                        onChange={(e) => setTime(e.target.value, naviSearch.transit.time.substr(2,2))}
                      >
                          {/* 0-23時のオプションが動的に生成される */}
                          {hourOptions.map((hour, index) => (
                            <option key={index} value={hour}                            >
                              {`${Number(hour)}時`}
                            </option>
                          ))}
                      </select>
                      <select id="transit-minute" className="datetime-select"
                        value={naviSearch.transit.time.substr(2,2)}
                        onChange={(e) => setTime(naviSearch.transit.time.substr(0,2), e.target.value)}
                      >
                          {/* 0-59分のオプションが動的に生成される */}
                          {minuteOptions.map((minute, index) => (
                            <option key={index} value={minute}>
                              {`${minute}分`}
                            </option>
                          ))}
                      </select>
                  </div>
                  
                  {/* 出発/到着選択 */}
                  <div className="departure-arrival-options">
                      <label className="radio-option">
                          <input type="radio" name="transit_timing" value="0"
                          checked={naviSearch.transit.transitMode === 0}
                          onClick={() => setNaviSearch({...naviSearch, transit: {...naviSearch.transit, transitMode: 0}})}
                          />
                          <span>出発</span>
                      </label>
                      <label className="radio-option">
                          <input type="radio" name="transit_timing" value="1"
                          checked={naviSearch.transit.transitMode === 1}
                          onClick={() => setNaviSearch({...naviSearch, transit: {...naviSearch.transit, transitMode: 1}})}
                          />
                          <span>到着</span>
                      </label>
                      <label className="radio-option">
                          <input type="radio" name="transit_timing" value="2"
                          checked={naviSearch.transit.transitMode === 2}
                          onClick={() => setNaviSearch({...naviSearch, transit: {...naviSearch.transit, transitMode: 2}})}
                          />
                          <span>始発</span>
                      </label>
                      <label className="radio-option">
                          <input type="radio" name="transit_timing" value="3"
                          checked={naviSearch.transit.transitMode === 3}
                          onClick={() => setNaviSearch({...naviSearch, transit: {...naviSearch.transit, transitMode: 3}})}
                          />
                          <span>終電</span>
                      </label>
                      <button type="button" className="current-time-btn" onClick={setCurrentDateTime}>現在時刻</button>
                  </div>
              </div>

              {/* 交通機関選択 */}
              <div className="transport-options">
                  <div className="transport-option-title">交通機関</div>
                  <div className="transport-checkboxes">
                      <label className="checkbox-option">
                          <input type="checkbox" name="transport_types" value="rail" checked={useAir}
                            onChange={(e) => { useAir = e.target.checked; setTransportation(); }}
                          />
                          <span>空路</span>
                      </label>
                      <label className="checkbox-option">
                          <input type="checkbox" name="transport_types" value="shinkansen" checked={useShinkansen}
                            onChange={(e) => { useShinkansen = e.target.checked; setTransportation(); }}
                          />
                          <span>新幹線</span>
                      </label>
                      <label className="checkbox-option">
                          <input type="checkbox" name="transport_types" value="limited_express" checked={useLimitedExpress}
                            onChange={(e) => { useLimitedExpress = e.target.checked; setTransportation(); }}
                          />
                          <span>有料特急</span>
                      </label>
                  </div>
              </div>

              {/* 表示順選択 */}
              <div className="display-order-options">
                  <div className="display-option-title">表示順</div>
                  <div className="display-order-radios">
                      <label className="radio-option">
                          <input type="radio" name="display_order" value="time"
                            checked={naviSearch.transit.sort === 'time,fare,transfer'}
                            onChange={() => setSort(0)}
                          />
                          <span>時間順 <i className="svg-icon-blue" style={{"background-image": "url('assets/icons/schedule_24.svg')"}}></i></span>
                      </label>
                      <label className="radio-option">
                          <input type="radio" name="display_order" value="price"
                            checked={naviSearch.transit.sort === 'fare,time,transfer'}
                            onChange={() => setSort(1)}
                          />
                          <span>料金順 <i className="svg-icon-blue" style={{"background-image": "url('assets/icons/currency_yen_24.svg')"}}></i></span>
                      </label>
                      <label className="radio-option">
                          <input type="radio" name="display_order" value="transfer"
                            checked={naviSearch.transit.sort === 'transfer,fare,time'}
                            onChange={() => setSort(2)}
                          />
                          <span>乗換順 <i className="svg-icon-blue" style={{"background-image": "url('assets/icons/swap_horiz_24.svg')"}}></i></span>
                      </label>
                  </div>
              </div>

              {/* 注意書き */}
              <div className="transit-notice">
                  <small>※「有料特急を利用しない」にすると普通列車が100km以上の場合、有料座席が表示される場合があります。</small>
              </div>
          </div>
  );
};

export default transitSetting;